<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<label
  class="custom-checkbox"
  [ngClass]="{
    'position-left': position === 'left',
    'position-right': position === 'right',
    disabled: disabled,
    selected: checked,
    partial: indeterminate,
  }"
  (click)="toggleChecked()"
  >
  <span class="checkbox-container">
    <input
      type="checkbox"
      class="hyperkit-component"
      [disabled]="disabled"
      [checked]="checked"
      [indeterminate]="indeterminate"
      />
    @if (checked && !indeterminate) {
      <hyperkit-icon
        color="inherit"
        size="small"
        icon="check"
        class="check-icon"
      ></hyperkit-icon>
    }
    @if (indeterminate) {
      <hyperkit-icon
        color="inherit"
        size="small"
        icon="minus"
        class="minus-icon"
      ></hyperkit-icon>
    }
  </span>
  @if (label) {
    <hyperkit-typography
      variant="body"
      size="md"
      color="inherit"
      (click)="$event.stopPropagation(); toggleChecked()"
      >
      {{ label }}
    </hyperkit-typography>
  }
</label>
